
import '../common/common';

import { getQueryParams } from '../lib/getQuery';
import { shopSdk } from '../graphql/shopClient';

const params = getQueryParams<Record<'token' | 'type', string>>();
async function checkQueryParams() {
  const contentEl = document.getElementById('pageContent');
  if (!contentEl) {
    console.warn("No page content element found, waiting and trying again");
    setTimeout(checkQueryParams, 250);
    return;
  }
  if (!params.token) {
    // No token, redirect to registration page
    window.location.href = '/account/register';
  } else {
    // Try to verify the token
    try {
      console.log({params})
      if (params.type === 'updateEmail') {
        await verifyUpdateEmailToken();
      } else {
        await verifyRegistrationToken();
      }
    } catch (err: any) {
      console.error("Error verifying token:", err);
      contentEl.innerText = "Error verifying token: " + err.message;
    }
  }
}
async function verifyRegistrationToken(password?: string) {
  const contentEl = document.getElementById('pageContent')!; // we only get here if we passed the test earlier
  const result = await shopSdk.verifyCustomerAccount({
    token: params.token.trim(),
    ...password ? { password } : {},
  });

  const data = result.verifyCustomerAccount;

  if (data.__typename === 'CurrentUser') {
    // It worked, so we are good!
    return returnToShop();
  }

  // still require password form if logged in but the token requires a password;
  // should be an incredibly rare edge case, but this handling is preferable IMO
  let msgHtml = data.__typename === 'MissingPasswordError' ? `` : `
    <div class="alert alert-success w-100 w-md-50 text-center" role="alert">
      <h4 class="alert-heading">Already logged in</h4>
      <p>This token is invalid, has been used, or has expired -- but you are already logged in.</p>

      <a href="/shop" class="btn btn-ss-iris">Back to Shop</a>
    </div>
  `;
  // This is used when cartPanel finds _userMessage after an isLoggedIn check.
  window._userMessage = {element: contentEl, html: msgHtml};
  if (window.current_user && msgHtml) {
    // We're already logged in
    contentEl.innerHTML = msgHtml;
    return;
  }
  let message = '';
  switch(data.__typename) {
    case 'VerificationTokenExpiredError':
      message = "This verification token has expired.";
      break;
    case 'VerificationTokenInvalidError':
      message = "This verification token has expired or is invalid.";
      break;
    case 'MissingPasswordError':
      showPasswordForm();
      return;
    default:
      message = "Could not verify token: " + data.__typename + " - " + data.message;
      break;
  }
  msgHtml = `
    <div class="alert alert-warning w-100 w-md-50 text-center" role="alert">
      <h4 class="alert-heading">Verification failed</h4>
      <p>${message}</p>

      <a href="/account/register" class="btn btn-ss-iris">Register</a>
    </div>
  `;
  contentEl.innerHTML = msgHtml;
}

async function handlePasswordSubmission(password: string, confirmPassword: string) {
  if (password !== confirmPassword) {
    showPasswordForm(true);
  } else {
    verifyRegistrationToken(password);
  }
}

function showPasswordForm(showError = false) {
  const tpl = `
    <div class="alert alert-info w-100 w-md-50 text-center" role="alert">
      <h4 class="alert-heading">Set Your Password</h4>
      <p>Please set a password to complete your account verification.</p>
      <form id="passwordForm" class="mt-3">
        <div class="form-floating mb-3">
          <input
            type="password"
            class="form-control"
            id="password"
            placeholder="Password"
            required
            minlength="8"
          />
          <label for="password">Password</label>
        </div>
        <div class="form-floating mb-3">
          <input
            type="password"
            class="form-control"
            id="confirmPassword"
            placeholder="Confirm Password"
            required
            minlength="8"
          />
          <label for="confirmPassword">Confirm Password</label>
        </div>
        ${showError ? `<div class="text-start text-danger mt-n2 mb-2">Passwords do not match</div>` : ``}
        <button type="submit" class="btn btn-primary w-100 py-2">Set Password</button>
      </form>
    </div>
  `;
  const contentEl = document.getElementById('pageContent')!;
  contentEl.innerHTML = tpl;

  // Add event listener for form submission
  document.getElementById('passwordForm')?.addEventListener('submit', e => {
    e.preventDefault();
    const password = (document.getElementById('password') as HTMLInputElement).value;
    const confirmPassword = (document.getElementById('confirmPassword') as HTMLInputElement).value;
    handlePasswordSubmission(password, confirmPassword);
  });
}

function returnToShop() {
  const contentEl = document.getElementById('pageContent')!; // we only get here if we passed the test earlier
  contentEl.innerHTML = `
    <div class="alert alert-success w-100 w-md-50 text-center" role="alert">
      <h4 class="alert-heading">Success!</h4>
      <p>Thanks for confirming your email address.</p>
      <a href="/shop" class="btn btn-ss-iris">Back to Shop</a>
    </div>
  `;
  setTimeout(() => window.location.href = '/shop', 3000)
}

async function verifyUpdateEmailToken() {
  const contentEl = document.getElementById('pageContent')!; // we only get here if we passed the test earlier
  const result = await shopSdk.updateCustomerEmailAddress({
    token: params.token.trim(),
  });

  const data = result.updateCustomerEmailAddress;

  if (data.__typename === 'Success') {
    return returnToShop();
  }

  let message = '';
  switch(data.__typename) {
    case 'IdentifierChangeTokenExpiredError':
      message = "This verification token has expired.";
      break;
    case 'IdentifierChangeTokenInvalidError':
      message = "This verification token has expired or is invalid.";
      break;
    default:
      message = "Could not verify token: " + data.__typename + " - " + data.message;
      break;
  }
  const msgHtml = `
    <div class="alert alert-warning w-100 w-md-50 text-center" role="alert">
      <h4 class="alert-heading">Verification failed</h4>
      <p>${message}</p>
      <a href="/shop" class="btn btn-ss-iris">Back to Shop</a>
    </div>
  `;
  contentEl.innerHTML = msgHtml;
}

checkQueryParams().catch(err => console.error("Error checking query params:", err));

document.getElementById('pageContent')?.classList.add('justify-content-center');
